import React from 'react'
import List from '@mui/material/List'
import Drawer from '@mui/material/Drawer';
import AppMenuItem from './AppMenuItem'
import appMenuItems from './AppMenuItemsList'
import Box from '@mui/material/Box'
import { useLocation } from 'react-router-dom'
import scrollToSection from '../../util/scrollToSection'




const AppMenu = (props) => {
  const location = useLocation()
  const routeName = location.pathname === '/' ? 'home' : location.pathname.slice(1)
  const [navSelected, setNavSelected] = React.useState(routeName)
  const [closeMenusVersion, setCloseMenusVersion] = React.useState(0)
  const pendingScrollTarget = React.useRef(null)

  const handleSectionSelect = (sectionId) => {
    pendingScrollTarget.current = sectionId
  }

  const handleDrawerExited = () => {
    const sectionId = pendingScrollTarget.current
    pendingScrollTarget.current = null
    if (sectionId) scrollToSection(sectionId)
  }

  React.useEffect(() => {
    if (location.pathname !== '/') {
      setNavSelected(routeName)
    }
  }, [location.pathname, routeName])

  const closeExpandableMenus = () => {
    setCloseMenusVersion((currentVersion) => currentVersion + 1)
  }

    const list = () =>(
        <Box
            //To decide width of Sidebar
            sx={{ width: 'auto', backgroundColor: '#E8F5F2', color: '#061B3A' }}
            role="presentation"  
            onKeyDown={props.toggleDrawer(false)}
            >

      <List sx={{ width: '100%' }} disablePadding>
      {appMenuItems.map((item, index) => (
        <AppMenuItem
          setMenu={setNavSelected}
          closeExpandableMenus={closeExpandableMenus}
          {...item}
          menuSelected={navSelected}
          closeMenusVersion={closeMenusVersion}
          toggleDrawer={props.toggleDrawer}
          onSectionSelect={handleSectionSelect}
          key={index}
        />
      ))}
            </List>
                
        </Box>
    )

  return (
    <div>
      <React.Fragment>
        <Drawer
          anchor="left"
          open={props.drawerState}
          onClose={props.toggleDrawer(false)}
          SlideProps={{ onExited: handleDrawerExited }}
          ModalProps={{ keepMounted: true }}
        >
          {list()}
        </Drawer>
      </React.Fragment>
    </div>
  );
}

export default AppMenu
